import { CompensationMethod } from "@redotech/redo-return-core-common/compensation-method";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum CompensationMethodsFilterQuery {
  INCLUDES_ANY = "includesAny",
  INCLUDES_ALL = "includesAll",
  INCLUDES_NONE = "includesNone",
}

const CompensationMethodsFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.COMPENSATION_METHODS,
  CompensationMethodsFilterQuery,
  z.array(createEnum(CompensationMethod)),
);
export const CompensationMethodsFilterSchema: z.ZodType<CompensationMethodsFilter> =
  CompensationMethodsFilterSchema_;
export interface CompensationMethodsFilter
  extends z.infer<typeof CompensationMethodsFilterSchema_> {}
